import type { RootState } from 'tradera/state/configure-store';

export const getSyiSlice = (state: RootState) => state.views.syi;
export const selectShortDescription = (state: RootState) =>
    getSyiSlice(state).shortDescription.shortDescription;
export const selectItemIdFromDraft = (state: RootState) =>
    getSyiSlice(state).draft?.itemId || undefined;
